module.exports = __webpack_public_path__ + "static/reko2-logo-00c5db286e90c8ebed5251f365cfd36c.png";